interface ColorInterface {
  [key: string]: string;
}

export const colors: ColorInterface = {
  background: "#f4f6f9",
  gray100: "#F9FAFB",
  blackText: "#667085",
  blue8ff: "#eff8ff",
  blue5ff: "#c4e5ff",
  bluee4e: "#E4E7EC",
  basegreen: "#28a745",
  gray9d9: "#d9d9d9",
  primary: "#074E9F",
  graylighter: "#8A95A8",
  graynormal: "#344054",
  greensecondary: "#22AB68",
  white: "#fff",
  black75: "rgba(0, 0, 0, 0.75)",
  blue8b4: "#0078b4",
  blue2f8: "#ECF2F8",
  gray2b3: "#98a2b3",
  redd4f: "#ff4d4f",
  green721: "#07A721",
  green8f2: "#F2F8F2",
  red545: "#dc3545",
  gray5f5: "#f5f5f5",
  gray480: "#6c7480",
  gray7f9: "#f6f7f9",
  redd20: "#D92D20",
  blurbc7: "#0086C9",
  greenb67: "#22AB67",
};
